module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8eed8e9cf5b6e386e496eb14f86564a6.png";